import React, {useState} from 'react'
import { Col, Row } from 'antd';

function Footer() {
    return (
      <Col style={{ marginTop: 10, backgroundColor: '#2f80ec', height: 150, padding: 20, borderRadius: 5}}>
        <Row>
          <h2 style={{ color: 'white'}}>
            Contact us
          </h2>
        </Row>
        <Row>
          <Col>
            <p style={{ color: 'white'}}>Email:</p>
          </Col>
          <Col>
            <p style={{ color: 'white', marginLeft: 10}}>countrycup2022@gmail.com</p>
          </Col>
        </Row>
      </Col>
    );

}

export { Footer }